<template>
  <div>
    <div class="box"  style="margin-top:20px">
      <div class="box-header">
        <h3>상주직원 정보 입력</h3>
        <small>상주직원 정보를 입력합니다.</small>
      </div>
      <div class="box-body">
        <form action="">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">이름</span>
            </label>
            <div class="col-4 pt-2">
              <input type="text"  v-model="data.visitorName" class="form-control form-control-success">
            </div>
            <label class="col-2 form-control-label">
              <span class="ess">회사/부서명</span>
            </label>
            <div class="col-4 pt-2">
              <input type="text"  v-model="data.visitorCompany" class="form-control form-control-success">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">카드번호</span>
            </label>
            <div class="col-4 pt-2">
              <input type="text" v-model="data.cardNumber"  class="form-control form-control-success">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="">비고</span>
            </label>
            <div class="col-10 pt-2">
              <textarea class="form-control w430" placeholder="메세지를 적어주세요." style="height:100px" v-model="data.memo"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">근무자</span>
            </label>
            <div class="col-10 pt-2">
              <div class="input-group align-top">
                <input type="text" v-model="data.checkInEmployeeName"  class="form-control form-control-success">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>



    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg blue"  @click="enterEmp()" :disabled="!(data.cardNumber && data.checkInEmployeeName && data.visitorCompany &&data.visitorName)">완료
        <i class="icon-check ml-5" ></i>
      </button>
    </div>
  </div>
</template>

<script>
import LocationTable from './LocationTable.vue';
import Dropdown from "@/components/Dropdown.vue"
export default {
  components: { LocationTable, Dropdown},
  props: {
    title: String,
    refId: String,
  },
  data(){
    return {
      data: {
        cardNumber: null,
        checkInEmployeeName: null,
        memo: null,
        visitIdcCode: null,
        visitorCompany: null,
        visitorName: null
      },
    }
  },
  computed: {
    currentIdc(){
      return this.$store.state.location.currentIdc;
    }
  },
  mounted(){
    setTimeout(()=>{
      $('.scroll-wrap').mCustomScrollbar({
        theme: 'dark-thick',
      });

    },500)

  },
  updated(){
    /*
    $('.modal .scroll-tbl .tbody').mCustomScrollbar({
      scrollButtons: { enable: false },
      theme: 'dark-thick',
      scrollbarPosition: 'outside',
    });
    */
  },
  methods: {
    enterEmp(){
      this.data.visitIdcCode = this.currentIdc.locationCode;
      let query = Object.entries(this.data).map(x => x.join("=")).join('&');
      this.$http.post('/api/private/visitor/checkInPermitedEmployee?'+query).then((result) => {
        // this.$toast.success('입실 완료 되었습니다.');
        this.noti('완료', '입실 완료 되었습니다.', 'success');
        this.closeModal();
        this.$attrs.opener.findAll();
      }).catch((e) =>{
        console.log(e);
      })
    },

  }
}
</script>

<style>

</style>
